import makeRequest from './client';

/**
 * Function to get/update release version.
 */
export const getReleaseVersion = () => makeRequest(`/release/version`, 'GET');

export const updateReleaseVersion = (payload: any) =>
  makeRequest('/release/version', 'POST', payload);
